import CampaignDetails from '@/src/components/campaigns/CampaignDetails';
import React from 'react';

export const CampaignDetailsPage: React.FC = () => {
  return <CampaignDetails />;
};
